import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import SubtitleSeparator from "./SubtitleSeparator";

VolumeSubtitle.propTypes = {
    productsSold: PropTypes.number,
    totalOrders: PropTypes.number,
};

function VolumeSubtitle({productsSold, totalOrders}) {
    if (!productsSold) {
        return null;
    }

    return (
        <div style={{
            display: "flex",
            alignItems: "center",
        }}>
            <FormattedMessage
                id='dashboard.saleValuesAndVolume.volume.subtitle.product'
                values={{products: productsSold.toLocaleString()}}
            />
            <SubtitleSeparator/>
            <FormattedMessage
                id='dashboard.saleValuesAndVolume.volume.subtitle.order'
                values={{totalOrders: totalOrders}}
            />
        </div>
    );
}

export default VolumeSubtitle;
